import './dynamic-image-style.scss'

import _ from 'lodash'
import React from 'react'

import NoImage from '../no-image/no-image'
import ImageTag from '../tag/image-tag'
import WPCFImage from '../wpCfImage'

const DynamicImage = ({ item, imageSizes }) => {
  const imageSrc = _.get(item, 'featuredImage.node.sourceUrl', undefined)

  return (
    <figure className="card-image">
      <div>
        {imageSrc ? (
          <WPCFImage
            src={imageSrc}
            width="1200"
            height="728"
            alt={_.get(item, 'featuredImage.node.altText', 'featured image')}
            bSizes={imageSizes}
            maxViewportWidth={30}
            style={{ height: '100%' }}
          />
        ) : (
          <NoImage />
        )}
        <ImageTag article={item} />
      </div>
    </figure>
  )
}

export default DynamicImage
